import { types, destroy } from 'mobx-state-tree';
import uuid from 'lodash/uniqueId';
import createStore from '../../lib/create-store';

const maxLength = 30;
const superList = [];
const marqueeList = [];

const initState = {
  marqueeList: [], // 普通跑道
  marqueeKey: 0,
  superList: [], // 超级跑道
};

const MarqueeItemType = types.enumeration('MarqueeItemType', [
  'Gift',
  'FortuneMsg',
  'Common',
  'TplMarquee',
]);

const MarqueeItem = types
  .model('MarqueeItemModel', {
    marqueeType: MarqueeItemType, // 跑道类型
    uid: '',
  })
  .volatile(() => ({
    item: {}, // 跑道数据，由于太繁琐了，所以设置为 可变数据
  }))
  .actions((self) => {
    const setItem = (item) => {
      self.item = item;
    };
    const setVisited = () => {
      self.isVisited = true;
    };
    return {
      setVisited,
      setItem,
    };
  });

export const Model = types
  .model('MarqueeModel', {
    currentSuperItem: types.maybeNull(MarqueeItem),
    marqueeList: types.array(MarqueeItem),
  })
  .views((self) => {
    return {};
  })
  .actions((self) => {
    const nextSuper = () => {
      if (self.currentSuperItem) {
        return;
      }
      const first = superList.shift();
      if (first) {
        const { marqueeType, uid, item } = first;
        const itemModel = MarqueeItem.create({ marqueeType, uid });
        itemModel.setItem(item);

        self.currentSuperItem = itemModel;
      }
    };

    const stopSuper = () => {
      self.currentSuperItem = null;
    };

    const stopMarquee = () => {
      if (self.marqueeList.length > 3) {
        destroy(self.marqueeList[0]);
      }
    };

    const nextMarquee = () => {
      if (self.marqueeList.length === 4) {
        return;
      }
      const first = marqueeList.shift();
      if (first) {
        const { marqueeType, uid, item } = first;
        const itemModel = MarqueeItem.create({ marqueeType, uid });
        itemModel.setItem(item);

        self.marqueeList.push(itemModel);
        if (self.marqueeList.length < 3) {
          nextMarquee();
        }
      }
    };

    const pushSuperItem = (tmplType, data) => {
      if (superList.length > maxLength) {
        superList.shift();
      }

      data.uid = uuid();
      superList.push({
        marqueeType: tmplType,
        item: data,
      });
      nextSuper();
    };

    const pushMarqueeItem = (tmplType, data) => {
      if (marqueeList.length > maxLength) {
        marqueeList.shift();
      }
      data.uid = uuid();
      marqueeList.push({
        marqueeType: tmplType,
        item: data,
      });
      nextMarquee();
    };

    return {
      pushMarqueeItem,
      pushSuperItem,
      nextSuper,
      stopSuper,
      stopMarquee,
      nextMarquee,
    };
  });

// export default {
//   initState,
//   Model
// };
let { store, Provider, useStore } = createStore(Model, initState);

export { store, Provider, useStore };
